exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd a:not(.md-button) {\n  color: #212529 !important;\n}\n", ""]);

// exports
